/**
 * Logic container for the live chat popup.
 */
class LiveChatPopup {
  liveChatOpenButton;
  liveChatGreetingWindow;
  liveChatGreetingCloseButton;

  liveChatId;
  liveChatApi;

  liveChatGreetingCloseButtonHoverTimeout;

  /**
   * Initializes the live chat popup.
   */
  init() {
    this.initializeContainers();
    this.getLiveChatId();
    this.loadLiveChatScript().then(() => {
      this.initLiveChat();
      this.initLiveChatGreeting();
    });
  }

  /**
   * Initializes the containers.
   */
  initializeContainers() {
    this.liveChatOpenButton = document.getElementById('live-chat-open-button');
    this.liveChatGreetingWindow = document.getElementById('live-chat-greeting-window');
    this.liveChatGreetingCloseButton = document.getElementById('live-chat-greeting-close-button');
  }

  /**
   * Gets the live chat ID from the query parameters.
   */
  getLiveChatId() {
    this.liveChatId = new URLSearchParams(window.location.search).get('liveChatId');

    if (!this.liveChatId) {
      throw new Error('Missing liveChatId query parameter');
    }
  }

  /**
   * Loads the Social Intents script
   *
   * @returns {Promise<void>} A promise that resolves when the script is loaded.
   */
  loadLiveChatScript() {
    return new Promise((resolve) => {
      window.onSIApiReady = () => {
        this.liveChatApi = window.SI_API;
        resolve(this.liveChatApi);
      };
      const script = document.createElement('script');
      script.async = true;
      script.src = `//www.socialintents.com/api/chat/socialintents.1.3.js#${this.liveChatId}`;
      document.querySelector('head').appendChild(script);
    });
  }

  /**
   * Initializes the live chat app.
   */
  initLiveChat() {
    this.liveChatApi.onChatOpened = () => this.hideLiveChatGreeting();
  }

  /**
   * Initializes the live chat greeting.
   */
  initLiveChatGreeting() {
    this.initLiveChatGreetingText();

    this.liveChatGreetingWindow.addEventListener('click', () => {
      this.showLiveChat();
    });

    this.liveChatGreetingWindow.addEventListener('mouseenter', () => {
      this.showLiveChatGreetingCloseButton();
    });

    this.liveChatGreetingWindow.addEventListener('mouseleave', () => {
      this.liveChatGreetingCloseButtonHoverTimeout = setTimeout(() => {
        this.hideLiveChatGreetingCloseButton();
      }, 700);
    });

    this.initLiveChatGreetingCloseButton();

    this.liveChatGreetingWindow.style.display = 'block';
  }

  /**
   * Initializes the live chat greeting text.
   */
  initLiveChatGreetingText() {
    const hasSeenPopup = JSON.parse(window.sessionStorage.getItem(`si_hasSeenPopup-${this.liveChatId}`) || 'false');

    if (hasSeenPopup) {
      this.liveChatGreetingWindow.innerHTML = 'Welcome back, let me know if you have any questions.';
    }
  }

  /**
   * Initializes the live chat greeting close button.
   */
  initLiveChatGreetingCloseButton() {
    this.liveChatGreetingCloseButton.addEventListener('mouseenter', () => {
      clearTimeout(this.liveChatGreetingCloseButtonHoverTimeout);
      this.showLiveChatGreetingCloseButton();
    });

    this.liveChatGreetingCloseButton.addEventListener('mouseleave', () => {
      this.hideLiveChatGreetingCloseButton();
    });

    this.liveChatGreetingCloseButton.addEventListener('click', () => {
      this.hideLiveChatGreeting();
    });
  }

  /**
   * Shows the live chat popup.
   */
  showLiveChat() {
    this.hideLiveChatGreeting();
    this.liveChatApi.showPopup();
  }

  /**
   * Hides the live chat greeting.
   */
  hideLiveChatGreeting() {
    this.hideLiveChatGreetingCloseButton();
    this.liveChatGreetingWindow.style.display = 'none';
  }

  /**
   * Shows the live chat greeting close button.
   */
  showLiveChatGreetingCloseButton() {
    this.liveChatGreetingCloseButton.style.display = 'block';
  }

  /**
   * Hides the live chat greeting close button.
   */
  hideLiveChatGreetingCloseButton() {
    this.liveChatGreetingCloseButton.style.display = 'none';
  }
}

window.addEventListener('load', () => new LiveChatPopup().init());
